// extracted by mini-css-extract-plugin
module.exports =  {"container":"container___Zm6T7","content":"content___SSOR2","title":"title___4zvDQ","tabsWrapper":"tabsWrapper___yucJh","tabs":"tabs___t20FO"};